/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SourceSurveyEnum {
    SearchEngine = 'searchEngine',
    Advertisement = 'advertisement',
    Social = 'social',
    FriendOrColleague = 'friendOrColleague',
    Kobeon = 'kobeon',
    Investown = 'investown',
    Other = 'other'
}

export function SourceSurveyEnumFromJSON(json: any): SourceSurveyEnum {
    return SourceSurveyEnumFromJSONTyped(json, false);
}

export function SourceSurveyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceSurveyEnum {
    return json as SourceSurveyEnum;
}

export function SourceSurveyEnumToJSON(value?: SourceSurveyEnum | null): any {
    return value as any;
}

